import { OrganizationId } from '@kaizenplatform/hugot-entity';
import CreditCard from '@material-ui/icons/CreditCard';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import getPurchasePointLinkUrl from '../../../utility/getPurchasePointLinkUrl';
import { Consumer as ConfigConsumer } from '../../context/config';
import ButtonWithIcon from '../primitive/ButtonWithIcon';

interface Props extends ClassAttributes<HTMLElement> {
  organizationId: OrganizationId;
  point?: number;
  className?: string;
}

const PurchasePointButton = ({ organizationId, point, className }: Props) => {
  return (
    <ConfigConsumer>
      {(config) => {
        const sender_url = encodeURIComponent(`${window.location.origin}/projects?org=${organizationId}`);
        const url = getPurchasePointLinkUrl(config.CORE_API_BASE_URL, organizationId, sender_url, point);
        return (
          <ButtonWithIcon
            icon={CreditCard}
            className={className}
            variant="outlined"
            component="a"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage id="purchase_point_button.label" />
          </ButtonWithIcon>
        );
      }}
    </ConfigConsumer>
  );
};

export default PurchasePointButton;
